import MusicActionTypes from './music.types';

export const fetchMusicStart = () => ({
    type: MusicActionTypes.FETCH_MUSIC_START
});

export const fetchMusicSuccess = linkMusic => ({
    type: MusicActionTypes.FETCH_MUSIC_SUCCESS,
    payload: linkMusic
});

export const fetchMusicFailure = error => ({
    type: MusicActionTypes.FETCH_MUSIC_FAILURE,
    payload: error
});

export const playMusic = () => ({
    type: MusicActionTypes.PLAY_MUSIC,
});

export const resetTrigger = () => ({
    type: MusicActionTypes.RESET_TRIGGER,
});

